import { ShareTypeEnum } from "@models/shares/share-type.enum";
import { SelectOption } from "@models/ui-models/select-options";

export const unitTrustShareTypesOptionsList: ShareTypeEnum[] = [
  ShareTypeEnum.ORD,
  ShareTypeEnum.A,
  ShareTypeEnum.B,
  ShareTypeEnum.C,
  ShareTypeEnum.D,
  ShareTypeEnum.E,
];

export const unitTrustShareTypesOptions: SelectOption<string>[] = unitTrustShareTypesOptionsList
  .map((type) => {
    return {
      value: type,
      label: type
    };
  });
